// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import CityServices from "services/CityServices";

// const FranchiseSelectCity = ({
//   selectedStates,
//   name,
//   label,
//   onChange,
//   selectedCities,
//   setSelectedCities,
//   selectedAllCityinState,
// }) => {

//   const [cities, setCities] = useState([]);

// //   useEffect(() => {
// //     const fetchCities = async () => {
// //       try {
// //         // If selectedAllCityinState contains values, fetch cities for those states

// //         if (
// //           selectedStates &&
// //           Array.isArray(selectedStates) &&
// //           selectedStates.length > 0
// //         ) {
// //           // Otherwise, fetch cities for selectedStates
// //           const isStringArray = typeof selectedStates[0] === "string";
// //           const hasValueKey = selectedStates[0].hasOwnProperty?.("value");

// //           const stateIds = isStringArray
// //             ? selectedStates
// //             : selectedStates
// //                 .map((state) => (hasValueKey ? state.value : null))
// //                 .filter(Boolean);

// //           const response = await CityServices.getCityByStateId(stateIds);
// //           // console.log("city id came 1", response);
// //           const cityList = Array.isArray(response?.data)
// //             ? response.data
// //             : Array.isArray(response)
// //             ? response
// //             : [];

// //           setCities(
// //             cityList?.map((city) => ({
// //               value: city.id_city,
// //               label: city.name,
// //             }))
// //           );
// //         }
// //         if (
// //           selectedAllCityinState &&
// //           Array.isArray(selectedAllCityinState) &&
// //           selectedAllCityinState.length > 0
// //         ) {
// //           // const stateIds = selectedAllCityinState.map((state) => state.value);
// //           const isStringArray = typeof selectedAllCityinState[0] === "string";
// //           const hasValueKey =
// //             selectedAllCityinState[0]?.hasOwnProperty?.("value");

// //           const stateIds = isStringArray
// //             ? selectedAllCityinState
// //             : selectedAllCityinState
// //                 .map((state) => (hasValueKey ? state.value : null))
// //                 .filter(Boolean);

// //           const response = await CityServices.getCityByStateId(stateIds);

// //           // console.log("came in 2", response);

// //           const cityList = Array.isArray(response?.data)
// //             ? response.data
// //             : Array.isArray(response)
// //             ? response
// //             : [];

// //           const allCities = cityList?.map((city) => ({
// //             value: city.id_city,
// //             label: city.name,
// //           }));

// //           // Automatically select all cities from these states
// //           setCities(allCities);
// //           const allCityIds = allCities.map((city) => city.value);
// //           // console.log("cityID",allCityIds);

// //           setSelectedCities(allCityIds); // Update selectedCities with all city IDs
// //           onChange(allCityIds); // Trigger onChange with all city IDs
// //         }
// //       } catch (error) {
// //         console.error("Error fetching cities:", error);
// //       }
// //     };

// //     fetchCities();
// //     // eslint-disable-next-line
// //   }, [selectedStates, selectedAllCityinState]);

// useEffect(() => {
//   const fetchCities = async () => {
//     try {
//       if (!selectedStates || selectedStates.length === 0) {
//         setCities([]);
//         setSelectedCities([]);
//         onChange([]);
//         return;
//       }

//       const isStringArray = typeof selectedStates[0] === "string";
//       const hasValueKey = selectedStates[0]?.hasOwnProperty?.("value");

//       const stateIds = isStringArray
//         ? selectedStates
//         : selectedStates
//             .map((state) => (hasValueKey ? state.value : null))
//             .filter(Boolean);

//       const response = await CityServices.getCityByStateId(stateIds);

//       const cityList = Array.isArray(response?.data)
//         ? response.data
//         : Array.isArray(response)
//         ? response
//         : [];

//       const mappedCities = cityList.map((city) => ({
//         value: city.id_city,
//         label: city.name,
//       }));

//       setCities(mappedCities);

//       const validCityIds = mappedCities.map((city) => city.value);

//       // Keep only valid selected cities
//       const filteredCities = (selectedCities || []).filter((id) =>
//         validCityIds.includes(Number(id))
//       );

//       if (
//         JSON.stringify(filteredCities) !==
//         JSON.stringify(selectedCities)
//       ) {
//         setSelectedCities(filteredCities);
//         onChange(filteredCities);
//       }

//       // Auto select all cities only once (Add mode)
//       if (
//         selectedAllCityinState &&
//         selectedAllCityinState.length > 0 &&
//         (!selectedCities || selectedCities.length === 0)
//       ) {
//         const allCityIds = mappedCities.map((city) => city.value);

//         setSelectedCities(allCityIds);
//         onChange(allCityIds);
//       }
//     } catch (error) {
//       console.error("Error fetching cities:", error);
//     }
//   };

//   fetchCities();
//   // eslint-disable-next-line
// }, [selectedStates]);

//   const handleCitySelect = (selectedOptions) => {
//     const selectedValues = selectedOptions.map((option) => option.value);
//     setSelectedCities(selectedValues);
//     onChange(selectedValues);
//   };

//   // const getSelectedOptions = () => {
//   //   console.log("Selected ---city",selectedCities);
//   //   return selectedCities
//   //    .map((value) => cities.find((city) => city.value == value))
//   //   // .map((value) => cities.find((city) => city.value === Number(value)))

//   //     .filter(Boolean);
//   // };

//   const getSelectedOptions = () => {
//     if (!Array.isArray(selectedCities) || selectedCities.length === 0) {
//       // console.log("No cities selected");
//       return [];
//     }

//     //console.log("Selected ---city", selectedCities);

//     return selectedCities
//       .map((value) => cities.find((city) => city.value == value))
//       .filter(Boolean);
//   };

//   const customStyles = {
//     indicatorsContainer: (provided) => ({
//       ...provided,
//       padding: "0", // Optional: Adjust padding
//     }),
//     indicatorSeparator: () => ({
//       display: "none", // Removes the separator line
//     }),
//   };

//   return (
//     <div>
//       {label && <label className="block text-sm font-medium">{label}</label>}
//       <Select
//         isMulti
//         name={name}
//         options={cities}
//         value={getSelectedOptions()}
//         onChange={handleCitySelect}
//         placeholder="--Choose--"
//         classNamePrefix="react-select"
//         className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
//         styles={customStyles}
//       />
//     </div>
//   );
// };

// export default FranchiseSelectCity;
import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import CityServices from "services/CityServices";

const SELECT_ALL_VALUE = "__SELECT_ALL_CITIES__";

const FranchiseSelectCity = ({
  selectedStates,
  name,
  label,
  onChange,
  selectedCities,
  setSelectedCities,
  id,
}) => {
  const [cities, setCities] = useState([]);

  const isEditMode = Boolean(id);

  // Always keep latest selected cities
  const selectedCitiesRef = useRef(
    Array.isArray(selectedCities) ? selectedCities.map(Number) : [],
  );

  // Previous selected states
  const previousStateIdsRef = useRef([]);
  useEffect(() => {
    selectedCitiesRef.current = Array.isArray(selectedCities)
      ? selectedCities.map(Number)
      : [];
  }, [selectedCities]);

  const getStateIds = (states) => {
    if (!Array.isArray(states)) {
      return [];
    }

    return states
      .map((state) => {
        if (typeof state === "string" || typeof state === "number") {
          return Number(state);
        }

        return Number(
          state?.value ?? state?.id ?? state?.state_id ?? state?.id_state,
        );
      })
      .filter((id) => !Number.isNaN(id));
  };

  const getCitiesFromResponse = (response) => {
    const cityList = Array.isArray(response?.data)
      ? response.data
      : Array.isArray(response)
        ? response
        : [];

    return cityList
      .map((city) => ({
        value: Number(city.id_city ?? city.id),
        label: city.name,
      }))
      .filter((city) => !Number.isNaN(city.value));
  };
  const stateIdsKey = useMemo(() => {
    const stateIds = getStateIds(selectedStates);

    return [...new Set(stateIds)].sort((a, b) => a - b).join(",");
  }, [selectedStates]);

  useEffect(() => {
    let cancelled = false;

    const fetchCities = async () => {
      try {
        const currentStateIds = getStateIds(selectedStates);
        if (currentStateIds.length === 0) {
          setCities([]);
          if (!isEditMode) {
            setSelectedCities([]);
            onChange([]);
          }

          previousStateIdsRef.current = [];

          return;
        }
        const response = await CityServices.getCityByStateId(currentStateIds);

        if (cancelled) {
          return;
        }

        const currentCities = getCitiesFromResponse(response);

        setCities(currentCities);

        const currentCityIds = currentCities.map((city) => Number(city.value));

        if (isEditMode) {
          console.log(
            "EDIT MODE - cities loaded, preserving backend selection",
          );

          previousStateIdsRef.current = currentStateIds;

          return;
        }

        const previousStateIds = previousStateIdsRef.current;
        if (previousStateIds.length === 0) {
          const allCityIds = currentCityIds;
          setSelectedCities(allCityIds);
          onChange(allCityIds);

          previousStateIdsRef.current = currentStateIds;

          return;
        }
        const addedStateIds = currentStateIds.filter(
          (stateId) => !previousStateIds.includes(stateId),
        );

        const removedStateIds = previousStateIds.filter(
          (stateId) => !currentStateIds.includes(stateId),
        );

        let finalSelectedCities = Array.isArray(selectedCitiesRef.current)
          ? selectedCitiesRef.current
              .map(Number)
              .filter((id) => !Number.isNaN(id))
          : [];

        if (addedStateIds.length > 0) {
          console.log("Fetching cities for newly added states:", addedStateIds);

          const addedResponse =
            await CityServices.getCityByStateId(addedStateIds);

          if (cancelled) {
            return;
          }

          const addedCities = getCitiesFromResponse(addedResponse);

          const addedCityIds = addedCities.map((city) => Number(city.value));

          console.log("Cities of newly added states:", addedCityIds);

          // Add new cities without duplicates
          finalSelectedCities = [
            ...new Set([...finalSelectedCities, ...addedCityIds]),
          ];
        }

        finalSelectedCities = finalSelectedCities.filter((cityId) =>
          currentCityIds.includes(cityId),
        );

        console.log("FINAL ADD MODE SELECTED CITIES:", finalSelectedCities);
        const oldValue = selectedCitiesRef.current.join(",");

        const newValue = finalSelectedCities.join(",");

        if (oldValue !== newValue) {
          selectedCitiesRef.current = finalSelectedCities;

          setSelectedCities(finalSelectedCities);

          onChange(finalSelectedCities);
        }

        // Save current states for next change
        previousStateIdsRef.current = currentStateIds;
      } catch (error) {
        if (!cancelled) {
          console.error("Error fetching cities:", error);
        }
      }
    };

    fetchCities();

    return () => {
      cancelled = true;
    };
  }, [stateIdsKey, isEditMode]);

  useEffect(() => {
    if (!isEditMode) {
      return;
    }

    if (!Array.isArray(selectedCities)) {
      return;
    }

    if (!Array.isArray(cities) || cities.length === 0) {
      return;
    }

    const validCityIds = cities.map((city) => Number(city.value));

    const backendSelectedCities = selectedCities
      .map(Number)
      .filter((cityId) => !Number.isNaN(cityId));

    const validSelectedCities = backendSelectedCities.filter((cityId) =>
      validCityIds.includes(cityId),
    );
    const oldValue = backendSelectedCities.join(",");

    const newValue = validSelectedCities.join(",");

    if (oldValue !== newValue) {
      selectedCitiesRef.current = validSelectedCities;

      setSelectedCities(validSelectedCities);

      onChange(validSelectedCities);
    }
  }, [isEditMode, cities, selectedCities, setSelectedCities, onChange]);
  const handleCitySelect = (selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      selectedCitiesRef.current = [];

      setSelectedCities([]);
      onChange([]);

      return;
    }

    const selectAllClicked = selectedOptions.some(
      (option) => option.value === SELECT_ALL_VALUE,
    );

    if (selectAllClicked) {
      const allCityIds = cities.map((city) => Number(city.value));

      selectedCitiesRef.current = allCityIds;

      setSelectedCities(allCityIds);

      onChange(allCityIds);

      return;
    }

    const selectedValues = selectedOptions
      .map((option) => Number(option.value))
      .filter((value) => !Number.isNaN(value));

    selectedCitiesRef.current = selectedValues;

    setSelectedCities(selectedValues);

    onChange(selectedValues);
  };

  const allCitiesSelected =
    cities.length > 0 &&
    Array.isArray(selectedCities) &&
    cities.every((city) =>
      selectedCities.map(Number).includes(Number(city.value)),
    );

  const cityOptions = [
    {
      value: SELECT_ALL_VALUE,
      label: allCitiesSelected ? "All Cities Selected" : "Select All Cities",
    },
    ...cities,
  ];

  const getSelectedOptions = () => {
    if (!Array.isArray(selectedCities) || selectedCities.length === 0) {
      return [];
    }

    return selectedCities
      .map((value) =>
        cities.find((city) => Number(city.value) === Number(value)),
      )
      .filter(Boolean);
  };

  const customStyles = {
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: "0",
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    option: (provided, state) => ({
      ...provided,

      cursor: "pointer",

      fontWeight: state.data.value === SELECT_ALL_VALUE ? "600" : "400",

      // Selected option
      backgroundColor: state.isSelected
        ? "#0E9F6E"
        : state.isFocused
          ? "#E8F5EF"
          : "white",

      color: state.isSelected ? "white" : "#111827",

      ":active": {
        backgroundColor: "#0E9F6E",
        color: "white",
      },
    }),

    menuList: (provided) => ({
      ...provided,

      maxHeight: "200px",
      height: "200px",

      overflowY: "auto",

      // Chrome / Edge / Safari scrollbar
      "&::-webkit-scrollbar": {
        width: "6px",
      },

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#0E9F6E",

        borderRadius: "10px",
      },

      "&::-webkit-scrollbar-track": {
        backgroundColor: "#E8F5EF",
      },

      // Firefox
      scrollbarWidth: "thin",

      scrollbarColor: "#0E9F6E #E8F5EF",
    }),

    multiValue: (provided) => ({
      ...provided,

      backgroundColor: "#0E9F6E",
      color: "black",
      borderRadius: "4px",
    }),

    multiValueLabel: (provided) => ({
      ...provided,

      color: "black",

      fontWeight: "500",
    }),

    multiValueRemove: (provided) => ({
      ...provided,

      color: "white",

      ":hover": {
        backgroundColor: "#0B7F59",

        color: "white",
      },
    }),

    control: (provided, state) => ({
      ...provided,

      minHeight: "40px",
      height: "fit-content",

      borderColor: state.isFocused ? "#0E9F6E" : provided.borderColor,

      boxShadow: state.isFocused ? "0 0 0 1px #0E9F6E" : provided.boxShadow,

      "&:hover": {
        borderColor: "#0E9F6E",
      },
    }),

    placeholder: (provided) => ({
      ...provided,

      color: "#6B7280",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "fit-content",
      minHeight: "40px",
      maxHeight: "200px",
      overflowY: "auto",
      padding: "2px 8px",
    }),
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium">{label}</label>}

      <Select
        isMulti
        name={name}
        options={cityOptions}
        value={getSelectedOptions()}
        onChange={handleCitySelect}
        placeholder="--Choose Cities--"
        classNamePrefix="react-select"
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
        styles={customStyles}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
      />
    </div>
  );
};

export default FranchiseSelectCity;
